<template>
  <div id="app">
    <div id="page_loader">
      <div id="page_loader_spinner">
        <div class="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div id="page_loader_progress" v-if="showProgress">
          <progress id="file" :value="progressValue" :max="progressMax">
            {{ progressValue }}%
          </progress>
        </div>
        <div id="page_loader_message" v-if="showLoaderMessage">
          {{ loaderMessage }}%
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    showLoaderMessage: function () {
      return this.$store.getters.showLoaderMessage;
    },
    loaderMessage: function () {
      return this.$store.getters.loaderMessage;
    },
    showProgress: function () {
      return this.$store.getters.showProgress;
    },
    progressValue: function () {
      return this.$store.getters.progressValue;
    },
    progressMax: function () {
      return this.$store.getters.progressMax;
    },
  },
};
</script>
<style scoped>
progress[value] {
  /* Reset the default appearance */
  -webkit-appearance: none;
  appearance: none;

  width: 250px;
  height: 20px;
}
progress[value]::-webkit-progress-bar {
  background-color: #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
  background-image: -webkit-linear-gradient(
      -45deg,
      transparent 33%,
      rgba(0, 0, 0, 0.1) 33%,
      rgba(0, 0, 0, 0.1) 66%,
      transparent 66%
    ),
    -webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
    -webkit-linear-gradient(left, rgb(5, 144, 125), rgb(3, 168, 48));

  border-radius: 2px;
  background-size: 35px 20px, 100% 100%, 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue